var c = 14;
function n(t, i) {
  if (!t || (t.type === Date && !t.width && (t.width = c), !t.width))
    return "";
  var a = i + 1;
  return '<col min="'.concat(a, '" max="').concat(a, '" width="').concat(t.width, '" customWidth="1"/>');
}
export {
  n as default
};
//# sourceMappingURL=index.es517.js.map
